import { Button, DialogContent, Stack, Typography } from "@mui/material";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import CancelDialogIcon from "@entrilia/shared/icons/CancelDialogIcon";
import type { Dashboard } from "../../../../api/types/dashboardsTypes";
import { pluralize } from "@entrilia/shared/utilities/stringHelper";

interface Props {
  dashboards: Dashboard[];
  onOkay: () => void;
  onCancel: () => void;
}

export default function CancelPromptDialog({ dashboards, onOkay, onCancel }: Props) {
  return (
    <SmallDialog open={true} hideBackdrop onClose={onCancel}>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between", px: 3, py: 2 }}>
        <Typography variant="h6" sx={{ fontFamily: "Roboto" }}>
          Stop Copying
        </Typography>
        <CloseIconButton onClick={onCancel} />
      </Stack>
      <DialogContent>
        <Stack sx={{ gap: 1.5, px: 2, alignItems: "center", textAlign: "center" }}>
          <CancelDialogIcon sx={{ width: 80, height: 80 }} />
          <Typography variant="h6" sx={{ fontFamily: "Roboto" }}>
            {pluralize("Stop copying dashboard", dashboards.length)}
          </Typography>
          <Typography color="textSecondary">Are you sure you want to stop copying the dashboard?</Typography>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onCancel}>
        <Button variant="outlined" color="error" onClick={onOkay}>
          Stop Copying
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
}
